export default (headers): string => {
  let fileName = 'sprievodne-dokumenty.zip';
  const contentDisposition = headers?.['content-disposition'];
  if (contentDisposition) {
    const regexMatch = contentDisposition.match(/.*filename="(.*)"/);
    if (regexMatch && regexMatch.length > 1) {
      // eslint-disable-next-line prefer-destructuring
      fileName = decodeURI(regexMatch[1]);
    }
  }
  return fileName;
};
